// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"root_xpr9Z","backgroundColorDanger":"backgroundColorDanger_+cWPb","backgroundColorSuccess":"backgroundColorSuccess_9lT5S"};